/**
 * Str.js
 *
 * A collection of string helpers.
 */
export default class Str {
  static ucfirst(value) {
    return (value + "").charAt(0).toUpperCase() + (value + "").slice(1);
  }

  static lcfirst(value) {
    return (value + "").charAt(0).toLowerCase() + (value + "").slice(1);
  }

  static ucwords(value) {
    return (value + "").replace(/^(.)|\s+(.)/g, function($1) {
      return $1.toUpperCase();
    });
  }

  static studlyCase(value) {
    value = value.replace(/[\-\_]/g, " ");
    value = this.ucwords(value);
    return value.replace(/\s/g, "");
  }

  static camelCase(value) {
    return this.lcfirst(this.studlyCase(value));
  }

  static slug(value) {
    return (value + "")
      .toLowerCase()
      .replace(/[\s_]+/g, "-") // replace spaces and underscores with -
      .replace(/[’'"]+/g, "") // remove quotes
      .replace(/[^\w\-]+/g, "") // remove all non word characters
      .replace(/\-{2,}/g, "-") // replace multiple - with single -
      .replace(/^\-*|\-*$/g, ""); // trim -
  }

  static random(length) {
    if (!length || isNaN(length)) {
      length = 16;
    }

    var chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var value = "";

    for (var i = 0; i < length; i++) {
      value += chars[Math.floor(Math.random() * chars.length)];
    }

    return value;
  }

  static shorten(str, length = 50, suffix = "...") {
    if (typeof str != "string") return str;
    if (str.length > length) {
      str = str.substr(0, length - 3) + suffix;
    }
    return str;
  }

  static strip_tags(str) {
    if (typeof str != "string") return str;
    return str.replace(/(<([^>]+)>)/gi, "");
  }
}
